var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/ban-types */
import Vue from 'vue';
import { cloneDeep, forEach, throttle, debounce, isEmpty } from "lodash-es";
import { compileFlow } from '../simpleFlow/compileFlow';
import { LazyGetter } from '@tencent/data-schema-core';
import { VNodeFactory } from './VNodeFactory';
import { unescapeSlotName } from "../../lib/utils/layout";
const hiddenAnySchema = {
  type: 'any',
  hidden: true
};
const scopedSlotInstancesLUT = new WeakMap();
const registerScopeSlotInstance = (compInstance, slotId, cRenderer) => {
  if (!compInstance || !cRenderer) return;
  let collection = scopedSlotInstancesLUT.get(compInstance);
  if (!collection) scopedSlotInstancesLUT.set(compInstance, collection = {});
  const set = collection[slotId] || (collection[slotId] = new Set());
  set.add(cRenderer);
};
const unregisterScopeSlotInstance = (compInstance, slotId, cRenderer) => {
  var _scopedSlotInstancesL;
  if (!compInstance || !cRenderer) return;
  (_scopedSlotInstancesL = scopedSlotInstancesLUT.get(compInstance)) === null || _scopedSlotInstancesL === void 0 || (_scopedSlotInstancesL = _scopedSlotInstancesL[slotId]) === null || _scopedSlotInstancesL === void 0 || _scopedSlotInstancesL.delete(cRenderer);
};
export class FactoryState {
  constructor(factory, ctx, defaultLayoutErrors, pluginRuntime) {
    this.cachedVNodeData = {};
    this.cachedVNode = undefined;
    this.destroyed = null;
    this.factory = factory;
    this.ctx = ctx;
    if (defaultLayoutErrors) this.layoutErrors = [...defaultLayoutErrors];
    if (pluginRuntime) this.pluginRuntime = pluginRuntime;
  }
  getScopedSlotInstances(slotId) {
    var _scopedSlotInstancesL2;
    const compInstance = this.ctx.componentInstances[this.factory.compPath];
    if (!compInstance) return [];
    return Array.from(((_scopedSlotInstancesL2 = scopedSlotInstancesLUT.get(compInstance)) === null || _scopedSlotInstancesL2 === void 0 || (_scopedSlotInstancesL2 = _scopedSlotInstancesL2[slotId]) === null || _scopedSlotInstancesL2 === void 0 ? void 0 : _scopedSlotInstancesL2.values()) || []);
  }
  /** 添加一个或者多个 layoutError 信息。如果有 key 的话，会做去重，保留最新的 */
  addLayoutErrors(...errors) {
    const filtered = errors.filter(Boolean);
    if (!this.layoutErrors) {
      if (!filtered.length) return;
      this.layoutErrors = [];
    }
    filtered.forEach(err => {
      const idx = !err.key ? -1 : this.layoutErrors.findIndex(x => x.key === err.key);
      if (idx !== -1) this.layoutErrors[idx] = err;else this.layoutErrors.push(err);
    });
  }
  deleteLayoutError(key) {
    if (!this.layoutErrors || !key) return;
    const idx = this.layoutErrors.findIndex(x => x.key === key);
    if (idx !== -1) {
      if (this.layoutErrors.length === 1) this.layoutErrors = undefined;else this.layoutErrors.splice(idx, 1);
    }
  }
  generateVueRenderFunctionForScopedSlot(slot) {
    const {
      isDesignMode,
      comp,
      compPath,
      uc
    } = this.factory;
    const slotId = slot.id;
    const {
      ctx
    } = this;
    const {
      renderer
    } = ctx;
    const designer = isDesignMode && uc.designer;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const ucScopedSlotOwner = this.factory;
    if (true) {
      var _comp$scopedSlots$slo, _comp$scopedSlots;
      const slotContent = (_comp$scopedSlots$slo = (_comp$scopedSlots = comp.scopedSlots) === null || _comp$scopedSlots === void 0 ? void 0 : _comp$scopedSlots[slotId]) !== null && _comp$scopedSlots$slo !== void 0 ? _comp$scopedSlots$slo : cloneDeep(slot.default);
      if (!slotContent) return;
      // 每一个作用域插槽可以视为一个子页面片
      const subPagelet = slotContent;
      const initialVNodeFactory = Object.freeze(new VNodeFactory({
        uc,
        comp: subPagelet.layout,
        parent: ucScopedSlotOwner,
        isScopeRoot: true,
        scopedSlotId: slotId
      }));
      // 最后为 Vue 得出那个作用域声明
      // console.log('>>>>> gen scoped fn', this.ctx.uid);
      return ssProps => {
        var _designer$renderer;
        const generateSourcesFromProps = () => {
          const ans = [];
          forEach(ssProps, (val, key) => {
            if (key.endsWith('Schema') || key.endsWith('-schema')) return; // schema 不需要
            let schema = ssProps[`${key}Schema`] || ssProps[`${key}-schema`];
            // 如果传入的没有 schema 就拉倒吧
            if (!schema && typeof schema !== 'object') schema = hiddenAnySchema;
            ans.push({
              id: key,
              schema,
              instance: val
            });
          });
          // // 最后，把上级页面弄进来
          // // TODO: 默认不展开 & 屏蔽掉搜索？
          // ans.push({
          //   id: 'ucParentRenderer',
          //   instance: renderer,
          //   schema: {
          //     ...renderer.ucDataStub.schema,
          //     title: '上级',
          //   },
          // });
          return ans;
        };
        // 每一次渲染，每一个格子，都创建 <c-renderer VNode
        const vnodeData = {
          props: {
            uc,
            ucInitialPagelet: subPagelet,
            ucInitialVNodeFactory: initialVNodeFactory,
            ucDataSourcesFromProps: generateSourcesFromProps(),
            ucScopedSlotOwner,
            ucScopedSlotId: slotId,
            onGeneratorVNode: ssProps.onGeneratorVNode
          },
          attrs: {
            ...(isDesignMode ? {
              'data-uc-scoped-slot-id': slotId,
              'data-uc-scoped-slot-owner': compPath
            } : null)
          },
          // 设计模式下要响应鼠标事件
          nativeOn: designer && ((_designer$renderer = designer.renderer) === null || _designer$renderer === void 0 ? void 0 : _designer$renderer.ucVNodeFactoryContext) === ctx ? {
            '!mousemove': ev => {
              const subCRenderer = subPageletVNode.componentInstance;
              if (!subCRenderer || ev.currentTarget !== subCRenderer.$el) return;
              designer.editZoneState.handleScopedSlotMouseMove(ev, {
                ownerCompPath: compPath,
                slotMeta: slot,
                subCRenderer
              });
            }
          } : undefined,
          // TODO: 把自己挂载上去
          // 详见 https://github.com/vuejs/vue/blob/edf7df0c837557dd3ea8d7b42ad8d4b21858ade0/packages/weex-vue-framework/factory.js#L5743
          hook: {
            // 子页面片实例化时，父级这里需要记录到 渲染CTX.scopedSlots
            insert(vnode) {
              registerScopeSlotInstance(ctx.componentInstances[compPath], slotId, vnode.componentInstance);
            },
            prepatch(_, vnode) {
              registerScopeSlotInstance(ctx.componentInstances[compPath], slotId, vnode.componentInstance);
            },
            postpatch(_, vnode) {
              registerScopeSlotInstance(ctx.componentInstances[compPath], slotId, vnode.componentInstance);
            },
            // 子页面片实例被销毁时，父级这里也需要更新 渲染CTX.scopedSlots
            destroy(vnode) {
              unregisterScopeSlotInstance(ctx.componentInstances[compPath], slotId, vnode.componentInstance);
            }
          }
        };
        const subPageletVNode = renderer.$createElement('uicore-c-renderer', vnodeData);
        return subPageletVNode;
      };
    }
  }
  /**
   * 这个是实打实的要给 VNode 用的 scopedSlots
   */
  get scopedSlots() {
    const {
      scopedSlotMetas: scopedSlots
    } = this.factory;
    if (!scopedSlots || !scopedSlots.length) return null;
    const ans = {};
    scopedSlots.forEach(slot => {
      const slotFn = this.generateVueRenderFunctionForScopedSlot(slot);
      const unescapedSlotId = unescapeSlotName(slot.id);
      if (slotFn) ans[unescapedSlotId] = slotFn;
    });
    return ans;
  }
  /**
   * 综合考虑了 <uc-slot /> 和 meta 的 slots，得到的总和列表
   *
   * 而且这里的列表会提供 getSlotContainerElement() 的方法，获取对应的 DOM
   */
  getNormalSlots() {
    var _this$factory$slotMet;
    const fixedSlotList = (_this$factory$slotMet = this.factory.slotMetas) === null || _this$factory$slotMet === void 0 ? void 0 : _this$factory$slotMet.filter(x => x.type === 'normal');
    const compInstance = this.ctx.componentInstances[this.factory.compPath];
    if (!compInstance) return fixedSlotList;
    const newList = Array.from(fixedSlotList || [], slot => ({
      ...slot,
      getSlotContainerElement() {
        if (slot.containerRef) {
          var _compInstance$$refs;
          let maybeResult = compInstance === null || compInstance === void 0 || (_compInstance$$refs = compInstance.$refs) === null || _compInstance$$refs === void 0 ? void 0 : _compInstance$$refs[slot.containerRef];
          if (Array.isArray(maybeResult)) maybeResult = maybeResult[0]; // eslint-disable-line prefer-destructuring
          if (!maybeResult) return null;
          if ('$el' in maybeResult) maybeResult = maybeResult.$el;
          if (maybeResult && 'nodeType' in maybeResult && maybeResult.nodeType === Node.ELEMENT_NODE) {
            return maybeResult;
          }
          return null;
        }
        // 古老的方式：通过 selector
        // 未来应该弃用
        if (typeof slot.selector === 'string') {
          const {
            selector
          } = slot;
          const el = compInstance === null || compInstance === void 0 ? void 0 : compInstance.$el;
          if (!el || el.nodeType !== Node.ELEMENT_NODE) return null;
          if (selector === '' || el.matches(selector)) return el; // 组件本身就是那个 slot 的容器！
          return el.querySelector(selector); // 在组件内寻找 slotContainer
        }
      }
    }));
    const {
      ucSlotInstances
    } = compInstance;
    if (ucSlotInstances) {
      Object.keys(ucSlotInstances).forEach(id => {
        const ucSlot = ucSlotInstances[id];
        if (!ucSlot) return;
        const oldIdx = newList.findIndex(x => x.id === id);
        if (oldIdx === -1) newList.push(ucSlot.slotMeta);else newList[oldIdx] = ucSlot.slotMeta;
      });
    }
    return newList.length ? Object.seal(newList) : undefined;
  }
  /**
   * 设计模式用的，根据组件的声明，获取 designerFlags 信息
   */
  getDesignerFlags() {
    var _this$factory$compMet;
    return (_this$factory$compMet = this.factory.compMeta) === null || _this$factory$compMet === void 0 ? void 0 : _this$factory$compMet.getDesignerFlags(this.factory);
  }
  /**
   * 获取一个事件的回调方法、执行状态等信息。
   */
  getFlowState(eventKey) {
    var _comp$events;
    if (this.flowStates && eventKey in this.flowStates) return this.flowStates[eventKey];
    // 如果缓存里没有过这个 flowState，就现在生成他！
    const {
      renderer
    } = this.ctx;
    const {
      compPath,
      comp,
      isDesignMode
    } = this.factory;
    const flow = (_comp$events = comp.events) === null || _comp$events === void 0 ? void 0 : _comp$events[eventKey];
    if (!flow) return null;
    if (!this.flowStates) this.flowStates = {};
    try {
      // 先尝试编译，不通过就放弃这个 event
      const ctxBase = renderer.getSimpleFlowCtxBaseOf(compPath);
      const execute = compileFlow(flow, ctxBase);
      const enableDebounce = flow.debounceConfig && flow.debounceConfig.type && (flow.debounceConfig.leading || flow.debounceConfig.trailing);
      // 合成 eventListener
      let eventListener = async (...args) => {
        // 对于一个组件的一个事件，会把当前在执行多少个 flow 的事情记下来
        const executingStatus = this.flowStates[eventKey];
        // 禁止重复触发的逻辑
        if (flow.debounce || enableDebounce) {
          if (executingStatus.pending) {
            console.warn(`Already running flow for ${eventKey} at ${compPath}`);
            return;
          }
        }
        // prepare data for flow executing
        const initialState = {};
        const eventData = {
          event: eventKey,
          compPath,
          target: ctxBase.target,
          uc: renderer.uc,
          renderer
        };
        // 真正开始执行
        executingStatus.pending += 1;
        const res = await execute({
          arguments: args,
          state: initialState
        }).then(ctx => [null, ctx], err => [err, err.flowCtx]).then(([error, flowCtx]) => {
          // 执行完计数器要 -1
          executingStatus.pending -= 1;
          if (error) {
            console.error(`Error occurs while executing flow ${eventData.event} at ${eventData.compPath}`, error);
          }
          const flowEndData = {
            ...eventData,
            flowCtx,
            flowStatus: flowCtx.flowStatus,
            error,
            state: flowCtx.state
          };
          if (error) throw error;
          return flowEndData;
        });
        if (!isEmpty(res === null || res === void 0 ? void 0 : res.state)) {
          return res === null || res === void 0 ? void 0 : res.state;
        }
      };
      if (enableDebounce) {
        // 包装一层 debounce
        const {
          debounceConfig
        } = flow;
        const fn = {
          throttle,
          debounce
        }[debounceConfig.type] || debounce;
        // @ts-ignore
        eventListener = fn(eventListener, debounceConfig.wait, {
          leading: debounceConfig.leading,
          trailing: debounceConfig.trailing
        });
      }
      // 如果是设计模式，需要做一个（快速的）参数检查
      if (isDesignMode) {
        // 要放在 nextTick，因为 ctxBase 里有组件的 instance getter
        Vue.nextTick(() => {
          // 逐条检查，遇到有问题的就不检查后续
          flow.steps.some(step => {
            const atom = ctxBase.atoms[step.type];
            const errors = atom === null || atom === void 0 ? void 0 : atom.validateParams(ctxBase, step.params);
            if (errors) {
              this.addLayoutErrors({
                key: `event:${eventKey}`,
                category: 'event',
                message: `事件 ${eventKey} 存在参数错误: ${errors.join(', ')}`
              });
              return true; // 停止检查
            }
            return false;
          });
        });
      }
      // 最后加入到 state 里，每次渲染可复用
      this.flowStates[eventKey] = {
        execute,
        eventListener,
        flow,
        pending: 0
      };
      return this.flowStates[eventKey];
    } catch (er) {
      // 编译出错
      this.addLayoutErrors({
        key: `event:${eventKey}`,
        category: 'event',
        message: `事件 ${eventKey} 的流程编译失败`,
        error: er
      });
      console.error(`[UICore] Component ${this.factory.comp.componentId || ''} ${compPath} has invalid event flow: ${eventKey}`, er);
      this.flowStates[eventKey] = null;
      return;
    }
  }
}
__decorate([LazyGetter()], FactoryState.prototype, "scopedSlots", null);